$(document).ready(function(){
  $("fieldset.js.product-form__input.product-form__input--pill input").eq(0).trigger("click")

var swiper = new Swiper(".top-picksMain", {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  });
  
var swiper = new Swiper(".ReviewBlocks", {
    slidesPerView: 3,
    loop: true,
    spaceBetween: 30,
    breakpoints: {
       320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      767: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      991: {
        slidesPerView: 3,
        spaceBetween: 20
      }
    }
  });


  var swiper = new Swiper(".instafeed_post", {
    slidesPerView: 5,
    loop: true,
    spaceBetween: 30,
    breakpoints: {
       320: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      767: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      991: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  });
  

  $('.marquee-sec').marquee({
    duration: 15000, 
    gap: 50, 
    delayBeforeStart: 0, 
    direction: 'left', 
    duplicated: true,
    startVisible: true
});
    
$('.addqty').on('click', function () {
  var container = $(this).closest('.productQuantity'); // Find the closest parent container
  var input = container.find('.quantity'); // Find the quantity input within that container

  var inputValue = parseInt(input.val());
  var maxValue = parseInt(input.attr('max'));
  var data_first_count = container.attr("first-count");
  if (inputValue < maxValue) {
    input.val(inputValue + 1);

    // var input_value = inputValue + 1
    // var calculate_val = data_first_count * input_value ;
    // var getexist_val =  $(this).parents(".productBundles").find(".variant-input-wrap .variant-input input[unit-name='"+calculate_val+"']").val();   
    // if(typeof getexist_val !== 'undefined'){
    //  $(this).parents(".productBundles").find(".variant-input-wrap .variant-input input[unit-name='"+calculate_val+"']").trigger("click");
    //  $(this).parents(".productBundles").find(".variant-input-wrap .variant-input").removeClass("active");
    //  $(this).parents(".productBundles").find(".variant-input-wrap .variant-input input[unit-name='"+calculate_val+"']").parents(".variant-input").addClass("active");
    // }
  }
});

 $('.subqty').on('click', function () {
   var container = $(this).closest('.productQuantity'); // Find the closest parent container
   var input = container.find('.quantity'); // Find the quantity input within that container

  var inputValue = parseInt(input.val());
  var minValue = parseInt(input.attr('min'));
  var data_first_count = container.attr("first-count");
  if (inputValue > minValue) {
    input.val(inputValue - 1);
    // var input_value = inputValue - 1
    // var calculate_val = data_first_count * input_value ;
    // var getexist_val =  $(this).parents(".productBundles").find(".variant-input-wrap .variant-input input[unit-name='"+calculate_val+"']").val();   
    // if(typeof getexist_val !== 'undefined'){
    // $(this).parents(".productBundles").find(".variant-input-wrap .variant-input input[unit-name='"+calculate_val+"']").trigger("click");
    // $(this).parents(".productBundles").find(".variant-input-wrap .variant-input").removeClass("active");
    // $(this).parents(".productBundles").find(".variant-input-wrap .variant-input input[unit-name='"+calculate_val+"']").parents(".variant-input").addClass("active");
    //  }
   }
});

      // Event handler for adding to bundle
 $(document).on('click', '.addBundles-btn', function(e) {
  e.preventDefault();
   $('.AddingBundles.Qty-based').css('display','block');
   $('.AddingBundles.Qty-based').css('pointer-events','none');
   $('.shipping_txt').css('display','block');
  // Get product details from the clicked button's parent container
  var productContainer = $(this).closest('.productBundles');
  var productName = productContainer.find('.product-title h2').text();
  var selectedVariant = productContainer.find('.hiddenselectorWp select option:selected');
  var variantTitle = productContainer.find(".GetdYnamic").attr('product-title')|| '';
  var variantPrice = parseFloat(productContainer.find(".GetdYnamic").attr('product-price').replace(/[^0-9.-]+/g,""));
  var variantQuantity = parseInt(productContainer.find('.quantity').val());
  var packs_count = productContainer.find('.variant-input-wrap .variant-input input:checked').attr("unit-name");
  var packs_count2 = productContainer.find('.variant-input-wrap').attr("data-count");
  if(typeof packs_count !== 'undefined' ){
    var final_packs = packs_count * variantQuantity
  }else{
    var final_packs = packs_count2 * variantQuantity
  }
  
  var ProductImage = productContainer.find('.productBundle-img img').attr('src');
  var productId = productContainer.find(".GetdYnamic").val(); // assume you have a data attribute with the product ID

  // Check if the product is already in the bundle
  var existingProduct = $('.AddBundles_InSide').find('[data-product-id="' + productId + '"]');
  if (existingProduct.length > 0) {
    // If the product is already in the bundle, update the quantity
    var existingQuantity = parseInt(existingProduct.find('.bundle_quantity span').text().replace('Quantity: ', ''));
    var existing_count = parseInt(existingProduct.attr("data-count"));
    var newcounthetre = existing_count + final_packs;
    var newQuantity = existingQuantity + variantQuantity;
    // var newcount = existingQuantity + variantQuantity;
    var totalPriceWp = variantPrice * newQuantity;
    existingProduct.find('.bundle_quantity span').text(newQuantity);
    existingProduct.find('.bundle_price span').text('Price: ' + totalPriceWp);
     existingProduct.attr("total-qty",newQuantity);
    existingProduct.attr("data-count",newcounthetre);
  } else {
    // If the product is not in the bundle, add it
    var totalPrice = variantPrice * variantQuantity;
    $('.AddBundles_InSide').append('<div class="bundlesItems" data-count="'+final_packs+'" total-qty="'+ variantQuantity  +'" data-product-id="' + productId + '">' +
                                     '<div class="bundle_product_image">' +
                                       '<img src="' + ProductImage + '" alt="Product Image">' +
                                   '<div class="bundle_quantity">' +
                                       '<span>' + variantQuantity + '</span>' +
                                     '</div>' +
                                     '</div>' +
                                    '<div class="bundle_details">' +
                                     '<div class="bundle_product_name">' +
                                       '<strong>' + productName + '</strong>' +
                                     '</div>' +
                                     '<div class="bundle_variant">' +
                                       '<span>' + variantTitle + ' x ' + variantQuantity + '</span>' +
                                     '</div>' +
                                     '<div class="bundle_price">' +
                                       '<span>Price: HK$' + totalPrice.toFixed(2) + '</span>' +
                                     '</div>' +
                                    '</div>' +
                                    '<div class="crossBundle">' +
                                       '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">' +
    '<path d="M9.63739 0.667838C9.62744 0.868233 9.4798 0.98215 9.35538 1.10771C8.17011 2.29761 6.98981 3.49415 5.79043 4.66992C5.51754 4.93683 5.5192 5.09731 5.79126 5.36423C6.97239 6.52004 8.13278 7.6958 9.29815 8.86657C9.40432 8.973 9.51049 9.08443 9.59261 9.20998C9.6797 9.34303 9.6374 9.4769 9.52127 9.58001C9.41842 9.67148 9.29483 9.69642 9.1812 9.61161C9.04932 9.51349 8.92407 9.40456 8.80795 9.28898C7.66829 8.15064 6.53112 7.00897 5.39312 5.86896C5.13047 5.6062 4.86366 5.61036 4.59271 5.88143C3.44476 7.03142 2.30095 8.18473 1.14636 9.32806C0.967203 9.50517 0.770624 9.84776 0.472853 9.55839C0.170935 9.2657 0.506031 9.06613 0.685191 8.88486C1.8572 7.70079 3.03086 6.51754 4.21946 5.35093C4.47576 5.09981 4.48903 4.94515 4.22526 4.68655C3.04579 3.52991 1.8854 2.35332 0.719199 1.18255C0.622153 1.08526 0.524279 0.987139 0.440505 0.879043C0.335995 0.744337 0.326042 0.597991 0.451288 0.467443C0.576534 0.337727 0.723346 0.336895 0.860204 0.439171C0.969691 0.52066 1.0684 0.618778 1.16544 0.716065C2.32418 1.8752 3.49203 3.02352 4.63086 4.20177C4.93278 4.51442 5.09784 4.47867 5.38068 4.18847C6.53278 3.00439 7.70811 1.84277 8.87679 0.675321C8.97384 0.578866 9.07254 0.474926 9.19115 0.412563C9.39769 0.302803 9.62993 0.445823 9.63739 0.667838Z" fill="#164154"/>' +
  '</svg>' +
                                     '</div>' +
                                   '</div>');
            }
  // productContainer.find('.quantity').val(1);
  var qtyy_count = 0;
  $(".bundlesItems").each(function() {
      var total_value = $(this).attr("data-count");
      qtyy_count += parseInt(total_value); 
  });
  if(qtyy_count >= 12){
    $('.addBundles-btn').addClass('not_addedBundle');
    // $('.addBundles-btn.not_addedBundle').css('pointer-events','none');
    $('.AddingBundles.Qty-based').addClass('now_clickable');
    $('.AddingBundles.Qty-based').css('pointer-events','auto');
  }

    });
  
  $(document).on('change', '.Product_variantWP .variant-wrapper input.variant_selection', function(e){
  $(this).parents('.variant-input').toggleClass('active').siblings().removeClass('active');
    // var data_index = $(this).attr("data-index");
    // $(this).parents(".productBundles").find(".productQuantity input").val(data_index);
  var concatenatedValues = "";
  $(this).parents('.Product_variantWP').find('.variant-wrapper input.variant_selection').each(function(){
    if ($(this).is(":checked")){
      var variant_value = $(this).parents('.variant-input').attr('data-value');
       concatenatedValues += variant_value + " / "; 
    }
  })
  concatenatedValues = concatenatedValues.replace(/\/\s*$/, ""); 
  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option').removeAttr('selected');
    $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('selected',true);
   var variant_id =  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('variant-id');
    var variant_Qty =  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('quantity');
    var variant_price =  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('variant-price');
    var currency =  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('store-currency');
    var variant_Image =  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('variant-image');
    var variant_title =  $(this).parents(".Product_variantWP").find('.hiddenselectorWp select option[variant-title="'+concatenatedValues.trim()+'"]').attr('variant-title');
    $(this).parents(".productBundles").find(".GetdYnamic").val(variant_id);
    $(this).parents(".productBundles").find(".GetdYnamic").attr("quantity",variant_Qty);
    $(this).parents(".productBundles").find(".GetdYnamic").attr("product-price",variant_price);
    $(this).parents(".productBundles").find(".GetdYnamic").attr("product-image",variant_Image);
     $(this).parents(".productBundles").find(".GetdYnamic").attr("product-title",variant_title);
   var selectedOption = $('.hiddenselector select option[variant-title="'+concatenatedValues.trim()+'"]').attr('selected',true)
   // var selectedPrice = selectedOption.attr('variant-price');
    $(this).parents(".productBundles").find('.product_price').text(currency + "" + variant_price);
 });
  

 $(document).on("click",".AddingBundles", function(){
    jsonObj = [];
    $(".bundlesItems").each(function(){
      var product_var =  $(this).attr("data-product-id");
        var product_qty =  $(this).attr("total-qty");
      item= {}    
      item['id'] = parseInt(product_var);
        item['quantity'] = parseInt(product_qty);
      jsonObj.push(item);
    });
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {items: jsonObj          },
      dataType: 'json',
      async: false,
      success: function (data) {location.href = '/cart';},
      error: function (jqXHR, textStatus, errorThrown) { console.log("error"); }
    });

  });

   $(document).on('click', '.crossBundle', function() {
      $(this).closest('.bundlesItems').remove();
  });


// blog page

$(document).on("click", ".custom_blog_tabs p.blogs-tabs-data", function() {
    $(".custom_blog_tabs p.blogs-tabs-data").removeClass("is__active");
    $(this).addClass("is__active");
    var url = $(this).attr("tag-url");
    $.ajax({
      type: 'GET',
      url: url,
      dataType: 'html',
      success: function(html_data) {
        $('.append_blog-data').html($(html_data).find('.append_blog-data').html());
      },
      error: function(xhr, status, error) {
        console.error('AJAX Error:', status, error);
      }
    });
  });

  $(".custom_blog_tabs p.blogs-tabs-data:first-child").trigger('click');
  
});